var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.actions),function(action,index){return _c('div',{key:index,staticClass:"inline-block pl-4"},[_c('button',{ref:"option",refInFor:true,staticClass:"text-left p-3 w-full",on:{"click":function($event){return _vm.handleAction(action.action)}}},[_vm._v("\n      "+_vm._s(action.label)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }